// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__5+7wU","spinner":"Spinner_spinner__R3LXC","spinner-aib1d7":"Spinner_spinner-aib1d7__nTHlk"};